import { writePortalPbCustomerJson } from '../../constants';
import type { CustomerRecord } from '../CustomerLogin';

export type PortalRole = 'it_admin' | 'member';
export type AccountKind = 'beta_tester' | 'demo_prospect' | 'customer';

export function parseAccountKind(raw: unknown): AccountKind {
  if (raw === 'beta_tester' || raw === 'demo_prospect' || raw === 'customer') {
    return raw;
  }
  return 'customer';
}

export function isBetaTester(accountKind?: AccountKind | null): boolean {
  return accountKind === 'beta_tester';
}

/** Kurzlebige Session — nur für Pflicht-Passwortwechsel direkt nach Login. */
export const PORTAL_TEMP_LOGIN_PW_KEY = 'portal_temp_login_pw';

export function buildCustomerRecord(record: Record<string, unknown>): CustomerRecord {
  const id = typeof record.id === 'string' ? record.id : '';
  const email = typeof record.email === 'string' ? record.email : '';
  if (!id || !email) {
    throw new Error('Ungültige Kunden-Antwort vom Server.');
  }
  const tierRaw = record.tier;
  const matrixRoomId =
    (typeof record.matrixRoomId === 'string' && record.matrixRoomId) ||
    (typeof record.matrix_room_id === 'string' && record.matrix_room_id) ||
    '';
  return {
    id,
    email,
    name: typeof record.name === 'string' ? record.name : '',
    kanzlei: typeof record.kanzlei === 'string' ? record.kanzlei : '',
    kanzlei_id:
      typeof record.kanzlei_id === 'string' && record.kanzlei_id.trim()
        ? record.kanzlei_id.trim().replace(/[^a-zA-Z0-9_-]/g, '_').substring(0, 80)
        : undefined,
    tier: tierRaw === 'premium' ? 'premium' : 'standard',
    matrixRoomId,
    status: typeof record.status === 'string' ? record.status : '',
    must_change_password: record.must_change_password === true,
    portal_role:
      record.portal_role === 'it_admin'
        ? 'it_admin'
        : record.portal_role === 'member'
          ? 'member'
          : undefined,
    is_primary: record.is_primary === true,
    account_kind: parseAccountKind(record.account_kind),
    included_seats:
      typeof record.included_seats === 'number' && Number.isFinite(record.included_seats)
        ? record.included_seats
        : undefined,
    max_seats:
      typeof record.max_seats === 'number' && Number.isFinite(record.max_seats)
        ? record.max_seats
        : undefined,
  };
}

/**
 * Orbis Professional (`standard`) und Premium — IT-Admin oder primärer Erst-Account.
 * Litigation bleibt premium-only; Sitze-UI gilt für beide Standard-Tarife.
 */
export function canManageTeamAccess(
  customer: Pick<CustomerRecord, 'tier' | 'portal_role' | 'is_primary'>,
): boolean {
  if (customer.tier !== 'premium' && customer.tier !== 'standard') return false;
  if (customer.portal_role === 'member') return false;
  return customer.portal_role === 'it_admin' || customer.is_primary === true;
}

export function persistPortalCustomer(customer: CustomerRecord): void {
  writePortalPbCustomerJson(JSON.stringify(customer));
}
